import InformatizaAps from '../pages/InformatizaAps/InformatizaAps';
import InformatizaApsPorEquipe from '../pages/InformatizaAps/PorEquipe';

export default [
    {
        path: '/informatiza-aps',
        component: () => import('@/pages/InformatizaAps/Template.vue'),
        children: [
            {
                path: '/informatiza-aps',
                component: InformatizaAps 
            },
            {
                path: '/informatiza-aps/equipe',
                component: InformatizaApsPorEquipe
            }
        ]
    }  
]